import React from 'react'
import Link from 'next/link'
import PubSub from 'pubsub-js'
import { sendTeaCommEvent } from 'lib/tea-analyze'

interface INavList {
  name: string
  query: string
}

const ConditionList: INavList[] = [
  {
    name: '10-15万',
    query: '10,15-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '15-20万',
    query: '15,20-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '20-25万',
    query: '20,25-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '25-30万',
    query: '25,30-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '新能源',
    query: 'x-x-x-x-x-x-4,5,6-x-x-x-x-x-x-x-x',
  },
  {
    name: '轿车',
    query: 'x-0-x-x-x-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: 'SUV',
    query: 'x-1-x-x-x-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '更多条件',
    query: 'x-x-x-x-x-x-x-x-x-x-x',
  },
]

export default function TypeList() {
  return (
    <ul className="select-car-type tw-grid tw-grid-cols-8 tw-gap-x-8">
      {ConditionList.map((item, index) => {
        return (
          <li key={`car-type-${index} tw-col-span-1`}>
            <Link href={`/auto/library/${item.query}`}>
              <a
                className="type-item fl"
                onClick={() => {
                  PubSub.publish('HIDE_HOVER_CAR')
                  PubSub.publish('OPEN_FIX_NAV', false)
                  sendTeaCommEvent('clk_event', {
                    event_id: 'common_select_car_menu_top_filter',
                    button_name: item.name,
                  })
                }}
              >
                {item.name}
              </a>
            </Link>
          </li>
        )
      })}
      <style jsx>
        {`
          .select-car-type {
            color: #1f2129;
            position: absolute;
            width: calc(100% - 40px);
          }
          .type-item {
            width: 100%;
            height: 36px;
            font-size: 12px;
            line-height: 36px;
            text-align: center;
            border-radius: 2px;
            background-color: #f7f8fc;
            margin-bottom: 12px;
          }
        `}
      </style>
    </ul>
  )
}
